module.exports = __webpack_public_path__ + "static/media/smalljerky.1e4601ed.webp";